import { useEffect, useState } from 'react';
import { MegaContact } from '../../../../types/contacts';
import { TabsWithTitle } from '../../tabsWithTitle';
import { TopUpMobileContacts } from '../topup-mobile-contacts';
import { TopUpMobilePhone } from '../topup-mobile-phone';

export type ContactsProps = {
  selectedContact: MegaContact | null;
  contacts: MegaContact[];
  subTab?: string;
};

export const TopupMobile = (props: ContactsProps) => {
  const [step, setStep] = useState<'contact' | 'other'>('other');
  const tabList = [
    { key: 'other', title: 'Otro Número' },
    { key: 'contact', title: 'Mis Contactos' },
  ];

  useEffect(() => {
    setStep(props.subTab === 'contact' ? 'contact' : 'other');
  }, [props.subTab]);

  return (
    <div>
      {props.contacts.length > 0 && (
        <TabsWithTitle
          title="Celular a Recargar"
          tabs={tabList}
          activeTab={step}
          wrapperClassName="mt-5"
          onTabChange={(key: string) => setStep(key as 'other' | 'contact')}
        />
      )}

      {step === 'other' && <TopUpMobilePhone selectedContact={props.selectedContact} />}
      {step === 'contact' && props.contacts.length > 0 && (
        <TopUpMobileContacts contacts={props.contacts} selectedContact={props.selectedContact} />
      )}
    </div>
  );
};
